// extracted by mini-css-extract-plugin
module.exports = {"span":"Span_span__dpovZ","highlighted":"Span_highlighted__MOYjv","spin":"Span_spin___qQ60","loader":"Span_loader__hpgtL"};